import swiperSlideshow from './slider'; // SLIDESHOW IMPORTED

export default function () {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;

  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection"></div>');

  $(`#${widgetName}`).videoWidget({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    detectIpad: IPADDETECTED,
    // options
    multiVideo: false,
    showOnMobile: true,
    maxVideos: 1,
    autoPlayVideo: false,
    loopVideo: false,
    videoWidgetLoaded: function (data) {
      if (data.Slides.length < 1) {
        // CONDITION TO COUNT VIDEO SLIDES
        $('#videoSection').remove(); // IF VIDEO IS NOT UPDATED WILL REMOVE VIDEOWIDGET AND RENDER SLIDESHOW
        swiperSlideshow();
        $('#swiperWidget').css('display', 'block');
      } else {
        $('#swiperWidget').remove();
        $('body').addClass('video-active');
        if (data.Slides.length > 0) {
          const autoplay = true;
          const showControls = false;
          const loopVideo = true;

          const videoStartTime = 0; // <<<< Time start to video (requires autoplay:true on widget settings)

          // ----------- //

          const autoplayString = `?rel=0&loop=${
            loopVideo ? '1' : '0'
          }&showcontrols=${showControls ? '1' : '0'}&showinfo=0&controls=${
            showControls ? '1' : '0'
          }&autoplay=${autoplay ? '1' : '0'}&mute=1&playlist=`;

          const videoSrc = $('#videoWidget iframe').attr('src');
          const getVideoCode = /embed\/([a-zA-Z0-9_-]+)\?/;
          const match = videoSrc.match(getVideoCode);
          const videoCodeUpdated = match ? match[1] : null;

          $('#videoWidget iframe').attr(
            'src',
            `https://www.youtube.com/embed/${videoCodeUpdated}${autoplayString}${videoCodeUpdated}${
              videoStartTime === 0 ? '' : `&amp;start=${videoStartTime}`
            }`
          );
        }
      }
    },
  });
}
